<div class="outer-el">
    <div autofocus class="search-contents">
        <div>
            <mat-form-field>
                <mat-select placeholder="{{'historyTexts.orderStatus' | translate}}" [(ngModel)]="displayOptions.status"
                    (selectionChange)="setOrderStatus()">
                    <mat-option *ngFor="let s of orderStatusLabels" [value]="getOrderStatusNumber(s)">
                        {{getOrderStatusText(s)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field>
                <mat-select placeholder="{{'historyTexts.planName' | translate}}" [(value)]="resetPlan">
                    <mat-option (click)="displayAllPlans()" [value]="0">
                        {{'historyTexts.all' | translate}}
                    </mat-option>
                    <mat-option *ngFor="let plan of plans" (click)="setSelectedPlan(plan.id)" [value]=plan>
                        {{getPlanName(plan)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="search-container">
                <input class="search-input" matInput placeholder="{{'historyTexts.orderCode' | translate}}"
                    [(ngModel)]="displayOptions.orderCode" (keydown.enter)="searchOrder()">
                <button *ngIf="displayOptions.orderCode" class="close-button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="clearText()">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>
        </div>
        <div>
            <mat-form-field>
                <input matInput [matDatepicker]="startDate" placeholder="{{'historyTexts.startDate' | translate}}"
                    [(ngModel)]="fromDate" (ngModelChange)="setRequestDates()" [max]="maxStartDateValue">
                <mat-datepicker-toggle matSuffix [for]="startDate">
                    <cqes-icon icon="calendar_today" class="calendar-icon">
                    </cqes-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #startDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
                <input matInput [matDatepicker]="endDate" placeholder="{{'historyTexts.endDate' | translate}}"
                    [(ngModel)]="toDate" (ngModelChange)="setRequestDates()" [min]="minEndDateValue">
                <mat-datepicker-toggle matSuffix [for]="endDate">
                    <cqes-icon icon="calendar_today" class="calendar-icon">
                    </cqes-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #endDate></mat-datepicker>
            </mat-form-field>
        </div>
        <button class="mat-mdc-raised-button action-button" (click)="searchOrder()">
            {{'historyTexts.searchOrders' | translate}}
        </button>

        <button class="mat-mdc-raised-button action-button" (click)="resetFilters()">
            {{'historyTexts.resetFilters' | translate}}
        </button>
    </div>

    <cloud-history-table-spinner *ngIf="isLoading" />

    <div class="message" *ngIf="!hasData() && !isLoading">
        {{'historyTexts.noDocumentsFound' | translate}}
    </div>

    <div class="data-container" [hidden]="!hasData() || isLoading">
        <div class="message" *ngIf="isOverLimit()">
            {{'historyTexts.first500Docs' | translate}}
        </div>

        <div class="mat-elevation-z8 table-content">
            <mat-table [dataSource]="orderHistoryDataSource" matSort matSortActive="orderDate" matSortDirection="desc">

                <ng-container matColumnDef="status">
                    <mat-header-cell mat-sort-header #status *matHeaderCellDef (click)="sortByHeader(status)">
                        {{'historyTexts.orderStatus' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let row" matTooltip="{{(row.status)?.tooltip | translate}}">
                        <cqes-icon [icon]="row.status.icon" [iconClass]="row.status.iconClass"></cqes-icon>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="orderCode">
                    <mat-header-cell class="d-block d-lg-flex d-none d-sm-flex" mat-sort-header #order_code
                        *matHeaderCellDef (click)="sortByHeader(order_code)">
                        {{'historyTexts.orderCode' | translate}} </mat-header-cell>
                    <mat-cell class="d-block d-lg-flex d-none d-sm-flex" *matCellDef="let row">
                        {{getPayOrderNumber(row)}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="orderDate">
                    <mat-header-cell class="d-none d-sm-flex" mat-sort-header #order_date *matHeaderCellDef
                        (click)="sortByHeader(order_date)">
                        {{'historyTexts.orderDate' | translate}}
                    </mat-header-cell>
                    <mat-cell class="d-none d-sm-flex" *matCellDef="let row">
                        {{row.orderDate | date: dateFormat}}<br>{{row.orderDate | date: timeFormat}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="paymentDate">
                    <mat-header-cell class="d-none d-lg-flex" mat-sort-header #payment_date *matHeaderCellDef
                        (click)="sortByHeader(payment_date)">
                        {{'historyTexts.paymentDate' | translate}}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="d-none d-lg-flex">
                        {{row.paymentDate | date: dateFormat}}<br>{{row.paymentDate | date: timeFormat}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="planName">
                    <mat-header-cell class="d-none d-lg-flex" mat-sort-header #plan_name *matHeaderCellDef
                        (click)="sortByHeader(plan_name)"> {{'historyTexts.planName'
                        | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="d-none d-lg-flex">{{row.planName[currentLang]}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="planSigningCount">
                    <mat-header-cell class="d-none d-lg-flex" mat-sort-header #plan_signing_count *matHeaderCellDef
                        (click)="sortByHeader(plan_signing_count)">
                        {{'historyTexts.signingCount' | translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="d-none d-lg-flex"
                        matTooltip="{{'historyTexts.signingCount' | translate}}">
                        {{row.planSigningCount | decodeHtmlString : row.planType}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="price">
                    <mat-header-cell mat-sort-header #price *matHeaderCellDef (click)="sortByHeader(price)">
                        {{'common.price' |
                        translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let row" matTooltip="{{'historyTexts.tooltips.price' | translate}}">
                        <span *ngIf="row?.orderDate">
                            <ng-container *ngIf="isBeforeCutoff(row.orderDate); else afterCutoff">
                                {{ row.price | localizedCurrency }}
                            </ng-container>
                            <ng-template #afterCutoff>
                                {{ row.price | currency:'EUR':'symbol':'1.2-2':'de-DE' }}
                            </ng-template>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions" class="tar">
                    <mat-header-cell *matHeaderCellDef translate> {{'common.actions'| translate}} </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <div>
                            <span [matMenuTriggerFor]="actionsMenu"
                                [style.visibility]=" containAXOrderNumber(row) && (notPaid(row.status) || hasInvoice(row))?  'visible': 'hidden'">
                                <button mat-icon-button color="primary">
                                    <cqes-icon icon="menu"></cqes-icon>
                                </button>
                            </span>
                            <mat-menu #actionsMenu [overlapTrigger]="false" class="nav-responsive-overlay menu">
                                <button *ngIf="notPaid(row.status)" mat-menu-item color="primary"
                                    matTooltip="{{'historyTexts.tooltips.pay' | translate}}" (click)="onPayment(row)"
                                    id="payment-btn">
                                    <cqes-icon icon="payment"></cqes-icon>
                                    {{'historyTexts.tooltips.pay' | translate}}
                                </button>
                                <button *ngIf="hasInvoice(row)" mat-menu-item color="primary"
                                    matTooltip="{{'common.download' | translate}}"
                                    (click)="onDownloadInvoice(row, 'Original')" id="download-file-btn">
                                    <cqes-icon icon="file_download"></cqes-icon>
                                    {{'common.download' | translate}}
                                </button>
                            </mat-menu>
                        </div>

                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <mat-paginator *ngIf="orderHistoryDataSource" [pageSize]="tableHelper.pageSize"
                [pageSizeOptions]="tableHelper.pageSizeOptions" (page)="onPaginateChange($event)">
            </mat-paginator>
        </div>
    </div>